import { IDualPlaybackLayoutOption } from '../hls/dual/IDualPlaybackLayoutOption';

import styles from './DualPlaybackLayouts.module.less';

const ICON_CLASS_PREFIX: string = 'vb-icon vb-icon-';

export const DUAL_PLAYBACK_LAYOUT_OPTIONS: IDualPlaybackLayoutOption[] = [
	{
		id: 'speakerBottomRight',
		class: styles.speakerBottomRightLayout,
		iconClass: 'speaker-bottom-right-layout'
	},
	{
		id: 'speakerTopRight',
		class: styles.speakerTopRightLayout,
		iconClass: 'speaker-top-right-layout'
	},
	{
		id: 'sideBySide',
		class: styles.sideBySideLayout,
		iconClass: 'side-by-side-layout'
	}
].map(option => ({
	...option,
	iconClass: ICON_CLASS_PREFIX + option.iconClass
}));


export const DUAL_PLAYBACK_LAYOUT_OPTIONS_V2: IDualPlaybackLayoutOption[] = [
	{
		id: 'onlyContent',
		class: styles.onlyContent,
		isContentOnly: true
	},
	{
		id: 'speaker20Content80',
		class: styles.speaker20Content80,
		isDefault: true
	},
	{
		id: 'speaker50Content50',
		class: styles.speaker50Content50
	},
	{
		id: 'speaker80Content20',
		class: styles.speaker80Content20
	},
	{
		id: 'onlySpeaker',
		class: styles.onlySpeaker,
		isSpeakerOnly: true
	}

].map(option => ({
	...option,
	class: `${styles.dualPlaybackActive} ${option.class}`
}));
